import { StateSchema } from 'app/config/storeConfig/types';
import { GlobalSettings } from '../types';

export const getGlobalSettings = (state: StateSchema): Nullable<GlobalSettings> => state.app.globalSettings;
